import { createFileRoute } from '@tanstack/react-router';
import { NamespaceBoundary } from '@/lib/i18n/NamespaceBoundary';
import { AgentPlatformPage } from '@/features/agent-platform/components/AgentPlatformPage';

export const Route = createFileRoute('/_auth/agent-platform')({ component: () => <NamespaceBoundary namespace="agentPlatform"><AgentPlatformPage /></NamespaceBoundary> });
